export const businessInformationGetters = {
  allBusinessInformations: (state) => state.allBusinessInformations,
  userBusinessInformation: (state) => state.userBusinessInformation,
};
